import React from "react"
import {Form} from "semantic-ui-react"
import {Trans, useTranslation} from "react-i18next";

const FormComment = ({step, onChange}) => {
    const {t} = useTranslation()
    let comment = <Trans i18nKey="general.comment">Kommentar</Trans>


    return (
        <Form.TextArea
            className="pt3"
            label={comment}
            autoHeight={true}
            placeholder={t("general.commentYour")}
            value={step.Comment || ""}
            onChange={(e, {value}) => {
                step.Comment = value
                onChange(value)
            }}/>
    )
}

export default FormComment



// WEBPACK FOOTER //
// ./src/pages/components/Step/FormComment.js